export default __webpack_public_path__ + "static/media/IncredibleAnimalsBuilders_05.bcc1abc5.png";